module.exports = __webpack_public_path__ + "img/jstree_checkbox_check_hover.7a40d35.png";